import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useDynamicTranslations } from '../common/hooks/useTranslations';

interface IProps {
  label?: any;
  lng?: any;
}

const MAPPER = {
  'Intervējamā vārds': 'intervejama_vards',
  'Intervējamā uzvārds': 'intervejama_uzvards',
  'Intervējamā dzīves gads': 'intervejama_dzimsanas_gads',
  'Intervējamā dzimšanas vieta': 'intervejama_dzimsanas_vieta',
  'Intervijas laiks': 'intervijas_laiks',
  'Intervijas vieta': 'intervijas_vieta',
  Vārds: 'vards',
  Uzvārds: 'uzvards',
  'Dzimšanas gads': 'dzimsanas_gads',
  'Dzimšanas vieta': 'dzimsanas_vieta',
};

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      infoLabelStyle: {
        fontWeight: FONT_WEIGHT.bold,
        fontSize: '16px',
        color: COLORS.appBlue,
        paddingBottom: '4px',
      },
    })
);

const SurveyAnswerInfoLabel = ({ label, lng }: IProps) => {
  const classes = useStyles();
  const labelId = MAPPER[label];
  const correctLabel = useDynamicTranslations(labelId, lng);

  return <div className={classes.infoLabelStyle}>{correctLabel}</div>;
};

export default SurveyAnswerInfoLabel;
